export function isUnauthorizedError(error: any) {
  return error?.response?.status === 401
}

export function isUnknownUserError(error: any) {
  return (
    isUnauthorizedError(error) && error?.response?.data?.code === 'USER_NOT_FOUND'
  )
}

export function isUnprocessableEntityError(error: any) {
  return error?.response?.status === 422
}

export function isNotFoundError(error: any) {
  return error?.response?.status === 404
}

export function isMaintenanceError(error: any) {
  return (
    error?.response?.status === 503 &&
    error?.response?.data?.code === 'MAINTENANCE'
  )
}

export function isConnectMeDeviceLimitReached(error: any) {
  return error?.response?.data?.error === 'connectme-device-limit-reached'
}

export function isConnectMeGeneralError(error: any): error is { status: number } {
  return error?.response?.data?.error === 'connectme-general-error';
}


export function isProvisioningError(error: any) {
  return error?.response?.data?.provisioning_error === 'Mac already exists'
}

export function isCatchAllExtensionError(error: any) {
  return error?.response?.data?.errors?.is_catch_all_extension
}

export function isDurationTooLongError(error: any) {
  return error?.response?.data?.message === 'Duration too long'
}

export function isInternalServerError(error: any) {
  return error?.response?.data?.provisioning_error === 'Internal server error'
}

export function isCatchAll422ExtensionError(error: any) {
  return (
    isUnprocessableEntityError(error) &&
    error?.response?.data?.errors?.is_catch_all_extension
  )
}

export function isCatchAllBulkExtensionError(error: any) {
  const errors = error?.response?.data?.errors ?? {}

  return (
    isUnprocessableEntityError(error) &&
    Object.entries(errors).some(
      ([key, messages]) =>
        key.startsWith('extension_ids') &&
        (messages as string[])?.some?.((message) =>
          message.includes('catch all extension')
        )
    )
  )
}

export function getCatchAllExtensionIds(error: any): number[] {
  const errors = error?.response?.data?.errors ?? {}
  const ids = new Set<number>()

  Object.entries(errors).forEach(([key, messages]) => {
    if (!key.startsWith('extension_ids')) return

    ;(messages as string[])?.forEach?.((message) => {
      const match = message.match(/Extension (\d+)/)
      if (match) {
        ids.add(Number(match[1]))
      }
    })
  })

  return [...ids]
}
export function isCatchAll422ResourceError(error: any) {
  return (
    error.response.status === 422 &&
    error.response.data.errors.is_catch_all_resource
  )
}

export function isEmailError(error: any, emailErrorMessage: string) {
  return (
    isUnprocessableEntityError(error) &&
    error.response?.data?.errors?.email?.some?.(
      (emailError: string) => emailError === emailErrorMessage
    )
  )
}

export function isFax2MailEmailInvalidDomainError(error: any) {
  return (
    isUnprocessableEntityError(error) &&
    error?.response?.data?.errors?.fax2MailEmail === 'isValidDomain' ||
    error?.response?.data?.errors?.email === 'isValidDomain'
  )
}

export function isEmailInvalidError(error: any) {
  return (
    isUnprocessableEntityError(error) &&
    error.response?.data?.isValidEmail === false
  )
}

export function isUsernameAlreadyTakenError(error: any) {
  return (
    isUnprocessableEntityError(error) &&
    error.response?.data?.errors?.username?.some?.(
      (usernameError: string) =>
        usernameError === 'The username has already been taken.'
    )
  )
}
